export class Antwort {
  id: string;
  text: string;
  adate: Date;
  frageId: string;
  gewaehlt: boolean;
  sollGewaehlt: boolean;
  selected: boolean;
}
